import React from 'react'
import { Block, Text } from '@mote/ui'
import { AddToChromeButton } from '@mote/presentation'

export const FreeTierPricingSection = ({ products }) => {
  return (
    <Block gap={16} margin='48px 0 0 0'>
      <Text fontSize={21} fontWeight={400}>
        {products.getCurrencySymbol()}0 - It's Free!
      </Text>

      <AddToChromeButton />
    </Block>
  )
}
